import { useQuery } from 'react-query';
import { getAllContactIdPossibleEventsByLicense } from 'services/ContactIdPossibleEventService';

export const useGetAllContactIdPossibleEventByLicense = () =>
  useQuery('contactIdPossibleEvents', getAllContactIdPossibleEventsByLicense, {
    keepPreviousData: true,
  });
